// import React from "react";
// import SideNavBar from "../SideNavBar";
// import AdminNavBar from "../AdminSideNavBar";
// import Settings from "../settings";
// import NetworkDetector from "../HigherOrderComponents/NetworkDetector";
// import authService from "../../services/authService";
// import SubAdminNavBar from "../SubAdminSideBar";
// import SettingsNew from "../settingsNew";

// const AccountSettingsPage = props => {
//   const user = authService.getCurrentUser();
//   let userData = {};
//   let manageUser = false;
//   if (props.location.state) {
//     userData = props.history.location.state.userData;
//     console.log("userData", userData);
//     manageUser = true;
//   }
//   if (!user.isAdmin && !user.isSubAdmin) {
//     return (
//       <React.Fragment>
//         <SideNavBar>
//           {/* <Settings /> */}
//           <SettingsNew />
//         </SideNavBar>
//       </React.Fragment>
//     );
//   } else if(user.isAdmin && !user.isSubAdmin) {
//     return (
//       <React.Fragment>
//         <AdminNavBar>
//           {/* <Settings data={userData} manageUser={manageUser} /> */}
//           <SettingsNew data={userData} manageUser={manageUser} />
//         </AdminNavBar>
//       </React.Fragment>
//     );
//   } else {
//     return (
//     <React.Fragment>
//       <SubAdminNavBar>
//         {/* <Settings  data={userData} manageUser={true}/> */}
//         <SettingsNew  data={userData} manageUser={true}/>
//       </SubAdminNavBar>
//     </React.Fragment>
//      );
//   }
// };

// export default NetworkDetector(AccountSettingsPage);





// import React from "react";
// import {
//   Box,
//   Container,
//   Paper,
//   Fade,
//   useTheme,
//   useMediaQuery,
//   Avatar,
//   Typography,
//   Chip,
//   Link as MuiLink
// } from "@mui/material";
// import {
//   Settings as SettingsIcon,
//   AdminPanelSettings as AdminIcon,
//   SupervisorAccount as SubAdminIcon,
//   Person as PersonIcon,
//   NavigateNext as NavigateNextIcon
// } from "@mui/icons-material";
// import SideNavBar from "../SideNavBar";
// import AdminNavBar from "../AdminSideNavBar";
// import SubAdminNavBar from "../SubAdminSideBar";
// import SettingsNew from "../settingsNew";
// import NetworkDetector from "../HigherOrderComponents/NetworkDetector";
// import authService from "../../services/authService";

// const AccountSettingsPage = props => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const user = authService.getCurrentUser();
  
//   const userData = props.location?.state?.userData || {};
//   const manageUser = Boolean(props.location?.state?.userData);

//   // Determine user role info
//   const getUserRoleInfo = () => {
//     if (user.isAdmin && !user.isSubAdmin) {
//       return {
//         role: "Administrator",
//         icon: <AdminIcon sx={{ fontSize: 40 }} />,
//         color: "#e91e63",
//         gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
//       };
//     } else if (user.isSubAdmin) {
//       return {
//         role: "Sub Administrator",
//         icon: <SubAdminIcon sx={{ fontSize: 40 }} />,
//         color: "#ff9800",
//         gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"
//       };
//     }
//     return {
//       role: "User",
//       icon: <PersonIcon sx={{ fontSize: 40 }} />,
//       color: "#2196f3",
//       gradient: "linear-gradient(135deg, #213a4f 1%, #0087fe 100%)"
//     };
//   };

//   const roleInfo = getUserRoleInfo();

//   // Enhanced header component
//   const SettingsHeader = () => (
//     <Box sx={{ mb: 4 }}>
//       {/* <Breadcrumbs 
//         separator={<NavigateNextIcon fontSize="small" />}
//         sx={{ mb: 2 }}
//       >
//         <MuiLink 
//           underline="hover" 
//           color="inherit" 
//           href="/dashboard"
//           sx={{ 
//             display: 'flex', 
//             alignItems: 'center',
//             '&:hover': { color: 'primary.main' }
//           }}
//         >
//           Dashboard
//         </MuiLink>
//         <Typography color="text.primary" fontWeight={500}>
//           Account Settings
//         </Typography>
//       </Breadcrumbs> */}

//       <Paper
//         elevation={0}
//         sx={{
//           background: roleInfo.gradient,
//           borderRadius: 3,
//           p: { xs: 2, sm: 3 },
//           color: 'white',
//           position: 'relative',
//           overflow: 'hidden',
//           '&::before': {
//             content: '""',
//             position: 'absolute',
//             top: 0,
//             right: 0,
//             width: '200px',
//             height: '200px',
//             background: 'rgba(255,255,255,0.1)',
//             borderRadius: '50%',
//             transform: 'translate(50%, -50%)'
//           },
//           '&::after': {
//             content: '""',
//             position: 'absolute',
//             bottom: 0,
//             left: 0,
//             width: '150px',
//             height: '150px',
//             background: 'rgba(255,255,255,0.05)',
//             borderRadius: '50%',
//             transform: 'translate(-30%, 30%)'
//           }
//         }}
//       >
//         <Box sx={{ 
//           display: 'flex', 
//           alignItems: 'center', 
//           gap: 2, 
//           position: 'relative', 
//           zIndex: 1,
//           flexDirection: { xs: 'column', sm: 'row' },
//           textAlign: { xs: 'center', sm: 'left' }
//         }}>
//           <Avatar
//             sx={{
//               width: { xs: 56, sm: 64 },
//               height: { xs: 56, sm: 64 },
//               bgcolor: 'rgba(255,255,255,0.2)',
//               backdropFilter: 'blur(10px)',
//               border: '2px solid rgba(255,255,255,0.3)',
//               boxShadow: '0 8px 16px rgba(0,0,0,0.2)'
//             }}
//           >
//             {roleInfo.icon}
//           </Avatar>
//           <Box sx={{ flex: 1 }}>
//             <Typography 
//               variant={isMobile ? "h5" : "h4"} 
//               sx={{ fontWeight: 700, mb: 1 }}
//             >
//               {manageUser ? 'Manage User Settings' : 'Account Settings'}
//             </Typography>
//             <Box sx={{ 
//               display: 'flex', 
//               gap: 1, 
//               alignItems: 'center', 
//               flexWrap: 'wrap',
//               justifyContent: { xs: 'center', sm: 'flex-start' }
//             }}>
//               <Chip
//                 label={roleInfo.role}
//                 size="medium"
//                 sx={{
//                   bgcolor: 'rgba(68, 148, 247, 0.81)',
//                   color: 'white',
//                   fontWeight: 600,
//                   backdropFilter: 'blur(10px)',
//                   border: '1px solid rgba(255, 255, 255, 0.88)'
//                 }}
//               />
//               {manageUser && userData.email && (
//                 <Chip
//                   label={userData.email}
//                   size="small"
//                   icon={<PersonIcon sx={{ color: 'white !important' }} />}
//                   sx={{
//                     bgcolor: 'rgba(29, 21, 21, 0.2)',
//                     color: 'white',
//                     backdropFilter: 'blur(10px)',
//                     border: '1px solid rgba(255,255,255,0.2)'
//                   }}
//                 />
//               )}
//             </Box>
//           </Box>
//           <SettingsIcon 
//             sx={{ 
//               fontSize: 48, 
//               opacity: 0.3,
//               display: { xs: 'none', md: 'block' },
//               animation: 'spin 20s linear infinite',
//               '@keyframes spin': {
//                 '0%': { transform: 'rotate(0deg)' },
//                 '100%': { transform: 'rotate(360deg)' }
//               }
//             }} 
//           />
//         </Box>
//       </Paper>
//     </Box>
//   );

//   // Enhanced content wrapper
//   const EnhancedSettingsContent = () => (
//     <Fade in timeout={600}>
//       <Container maxWidth="xl" sx={{ py: { xs: 2, sm: 4 } }}>
//         <SettingsHeader />
//         <Paper
//           elevation={0}
//           sx={{
//             borderRadius: 3,
//             border: '1px solid',
//             borderColor: 'divider',
//             overflow: 'hidden',
//             bgcolor: 'background.paper',
//             boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
//             transition: 'box-shadow 0.3s ease',
//             '&:hover': {
//               boxShadow: '0 8px 30px rgba(0,0,0,0.12)'
//             }
//           }}
//         >
//           <SettingsNew 
//             data={userData} 
//             manageUser={manageUser}
//           />
//         </Paper>
//       </Container>
//     </Fade>
//   );

//   // Render with appropriate navigation
//   const renderWithNav = (NavComponent) => (
//     <React.Fragment>
//       <NavComponent>
//         <EnhancedSettingsContent />
//       </NavComponent>
//     </React.Fragment>
//   );

//   // Regular user
//   if (!user.isAdmin && !user.isSubAdmin) {
//     return renderWithNav(SideNavBar);
//   }
  
//   // Admin user
//   if (user.isAdmin && !user.isSubAdmin) {
//     return renderWithNav(AdminNavBar);
//   }
  
//   // SubAdmin user - override manageUser to true
//   return (
//     <React.Fragment>
//       <SubAdminNavBar>
//         <Fade in timeout={600}>
//           <Container maxWidth="xl" sx={{ py: { xs: 2, sm: 4 } }}>
//             <SettingsHeader />
//             <Paper
//               elevation={0}
//               sx={{
//                 borderRadius: 3,
//                 border: '1px solid',
//                 borderColor: 'divider',
//                 overflow: 'hidden',
//                 bgcolor: 'background.paper',
//                 boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
//                 transition: 'box-shadow 0.3s ease',
//                 '&:hover': {
//                   boxShadow: '0 8px 30px rgba(0,0,0,0.12)'
//                 }
//               }}
//             >
//               <SettingsNew 
//                 data={userData} 
//                 manageUser={true}
//               />
//             </Paper>
//           </Container>
//         </Fade>
//       </SubAdminNavBar>
//     </React.Fragment>
//   );
// };

// export default NetworkDetector(AccountSettingsPage);


import React from "react";
import {
  Box,
  Container,
  Paper,
  Fade,
  useTheme,
  useMediaQuery,
  Avatar,
  Typography,
  Chip,
  Breadcrumbs,
  Link as MuiLink,
  Stack
} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import {
  Settings as SettingsIcon,
  AdminPanelSettings as AdminIcon,
  SupervisorAccount as SubAdminIcon,
  Person as PersonIcon,
  NavigateNext as NavigateNextIcon,
  Security as SecurityIcon,
  Dashboard as DashboardIcon
} from "@mui/icons-material";
import SideNavBar from "../SideNavBar";
import AdminNavBar from "../AdminSideNavBar";
import SubAdminNavBar from "../SubAdminSideBar";
import SettingsNew from "../settingsNew";
import NetworkDetector from "../HigherOrderComponents/NetworkDetector";
import authService from "../../services/authService";

const AccountSettingsPage = props => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const user = authService.getCurrentUser();
  
  const userData = props.location?.state?.userData || {};
  const manageUser = Boolean(props.location?.state?.userData);

  // Determine user role info
  const getUserRoleInfo = () => {
    if (user.isAdmin && !user.isSubAdmin) {
      return {
        role: "Administrator",
        icon: <AdminIcon sx={{ fontSize: 40 }} />,
        color: "#e91e63",
        gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        badgeColor: "secondary"
      };
    } else if (user.isSubAdmin) {
      return {
        role: "Sub Administrator",
        icon: <SubAdminIcon sx={{ fontSize: 40 }} />,
        color: "#ff9800",
        gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
        badgeColor: "warning"
      };
    }
    return {
      role: "User",
      icon: <PersonIcon sx={{ fontSize: 40 }} />,
      color: "#2196f3",
      gradient: "linear-gradient(135deg, #213a4f 1%, #0087fe 100%)",
      badgeColor: "info"
    };
  };

  const roleInfo = getUserRoleInfo();

  // Enhanced header component
  const SettingsHeader = () => (
    <Box sx={{ mb: 4 }}>
      <Breadcrumbs 
        separator={<NavigateNextIcon fontSize="small" />}
        sx={{ mb: 3 }}
        aria-label="breadcrumb"
      >
        <MuiLink
          component="button"
          underline="hover"
          color="inherit"
          onClick={() => props.history.push('/dashboard')}
          sx={{ 
            display: 'flex', 
            alignItems: 'center',
            gap: 0.5,
            '&:hover': { color: 'primary.main' }
          }}
        >
          <DashboardIcon fontSize="small" />
          Dashboard
        </MuiLink>
        <Typography color="text.primary" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <SecurityIcon fontSize="small" />
          Account Settings
        </Typography>
      </Breadcrumbs>

      <Paper
        elevation={3}
        sx={{
          background: roleInfo.gradient,
          borderRadius: 4,
          p: { xs: 3, sm: 4 },
          color: 'white',
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            right: 0,
            width: '300px',
            height: '300px',
            background: 'rgba(255,255,255,0.1)',
            borderRadius: '50%',
            transform: 'translate(30%, -30%)'
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '200px',
            height: '200px',
            background: 'rgba(255,255,255,0.05)',
            borderRadius: '50%',
            transform: 'translate(-20%, 20%)'
          }
        }}
      >
        <Grid2 container spacing={3} alignItems="center" sx={{ position: 'relative', zIndex: 1 }}>
          <Grid2 xs={12} sm="auto">
            <Avatar
              sx={{
                width: { xs: 80, sm: 100 },
                height: { xs: 80, sm: 100 },
                bgcolor: 'rgba(255,255,255,0.2)',
                backdropFilter: 'blur(10px)',
                border: '3px solid rgba(255,255,255,0.3)',
                boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                margin: { xs: '0 auto', sm: 0 }
              }}
            >
              {roleInfo.icon}
            </Avatar>
          </Grid2>
          
          <Grid2 xs={12} sm>
            <Box sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
              <Typography 
                variant={isMobile ? "h5" : "h4"} 
                sx={{ 
                  fontWeight: 700, 
                  mb: 1.5,
                  textShadow: '2px 2px 4px rgba(0,0,0,0.2)'
                }}
              >
                {manageUser ? 'Manage User Settings' : 'Account Settings'}
              </Typography>
              
              <Stack 
                direction={{ xs: 'column', sm: 'row' }} 
                spacing={1} 
                alignItems={{ xs: 'center', sm: 'flex-start' }}
                flexWrap="wrap"
              >
                <Chip
                  label={roleInfo.role}
                  color={roleInfo.badgeColor}
                  size="medium"
                  icon={roleInfo.icon}
                  sx={{
                    fontWeight: 600,
                    backdropFilter: 'blur(10px)',
                    bgcolor: 'rgba(255,255,255,0.2)',
                    color: 'white',
                    border: '1px solid rgba(255,255,255,0.3)',
                    '& .MuiChip-icon': { color: 'white' }
                  }}
                />
                
                {manageUser && userData.email && (
                  <Chip
                    label={userData.email}
                    size="small"
                    icon={<PersonIcon />}
                    sx={{
                      bgcolor: 'rgba(0,0,0,0.2)',
                      color: 'white',
                      backdropFilter: 'blur(10px)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      '& .MuiChip-icon': { color: 'white' }
                    }}
                  />
                )}
              </Stack>
            </Box>
          </Grid2>
          
          {!isTablet && (
            <Grid2 xs="auto">
              <Box
                sx={{
                  animation: 'spin 20s linear infinite',
                  '@keyframes spin': {
                    '0%': { transform: 'rotate(0deg)' },
                    '100%': { transform: 'rotate(360deg)' }
                  }
                }}
              >
                <SettingsIcon sx={{ fontSize: 60, opacity: 0.3 }} />
              </Box>
            </Grid2>
          )}
        </Grid2>
      </Paper>
    </Box>
  );

  // Enhanced content wrapper
  const EnhancedSettingsContent = () => (
    <Fade in timeout={600}>
      <Container maxWidth="xl" sx={{ py: { xs: 2, sm: 4 } }}>
        <SettingsHeader />
        <Paper
          elevation={0}
          sx={{
            borderRadius: 4,
            border: '1px solid',
            borderColor: 'divider',
            overflow: 'hidden',
            bgcolor: 'background.paper',
            boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
            transition: 'all 0.3s ease',
            '&:hover': {
              boxShadow: '0 12px 48px rgba(0,0,0,0.12)'
            }
          }}
        >
          <SettingsNew 
            data={userData} 
            manageUser={manageUser}
          />
        </Paper>
      </Container>
    </Fade>
  );

  // Render with appropriate navigation
  const renderWithNav = (NavComponent) => (
    <NavComponent>
      <EnhancedSettingsContent />
    </NavComponent>
  );

  // Regular user
  if (!user.isAdmin && !user.isSubAdmin) {
    return renderWithNav(SideNavBar);
  }
  
  // Admin user
  if (user.isAdmin && !user.isSubAdmin) {
    return renderWithNav(AdminNavBar);
  }
  
  // SubAdmin user
  return renderWithNav(SubAdminNavBar);
};

export default NetworkDetector(AccountSettingsPage);
